"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxUpdateGroupArgs = void 0;
function serializeHxUpdateGroupArgs(_arg) {
    var output = [];
    output.push(_arg.name !== undefined);
    if (_arg.name !== undefined) {
        output.push(_arg.name);
    }
    output.push(_arg.groupDescription !== undefined);
    if (_arg.groupDescription !== undefined) {
        output.push(_arg.groupDescription);
    }
    output.push(_arg.accessType !== undefined);
    if (_arg.accessType !== undefined) {
        output.push(_arg.accessType);
    }
    output.push(_arg.shouldAutosubscribeNewMembers !== undefined);
    if (_arg.shouldAutosubscribeNewMembers !== undefined) {
        output.push(_arg.shouldAutosubscribeNewMembers);
    }
    output.push(_arg.classification !== undefined);
    if (_arg.classification !== undefined) {
        output.push(_arg.classification);
    }
    output.push(_arg.language !== undefined);
    if (_arg.language !== undefined) {
        output.push(_arg.language);
    }
    output.push(_arg.isMembershipHidden !== undefined);
    if (_arg.isMembershipHidden !== undefined) {
        output.push(_arg.isMembershipHidden);
    }
    output.push(_arg.allowExternalSenders !== undefined);
    if (_arg.allowExternalSenders !== undefined) {
        output.push(_arg.allowExternalSenders);
    }
    output.push(_arg.mipLabelId !== undefined);
    if (_arg.mipLabelId !== undefined) {
        output.push(_arg.mipLabelId.toString());
    }
    return output;
}
exports.serializeHxUpdateGroupArgs = serializeHxUpdateGroupArgs;
